/**
 * A catalog item's name in the reader's language (§2.8: every item carries
 * both). Hebrew is the fallback when English is missing, never the other way
 * round — Hebrew is what the unit reads.
 */
export function itemName(
  item: { nameHe: string | null; nameEn: string | null },
  language: string,
): string {
  const he = item.nameHe ?? item.nameEn ?? '';
  const en = item.nameEn ?? item.nameHe ?? '';
  return language.startsWith('en') ? en : he;
}
